authTokenNewRelicSuccessData